import axios from 'axios'
import { ServerEnv } from 'Configs/ServerEnv'
import StorePaymentStep from 'GlobalStores/Cores/Elements/StorePaymentStep'
import { get } from 'lodash'
import { makeAutoObservable, runInAction, toJS } from 'mobx'
import { FeelGreatAPI } from 'Services/FeelGreat/APIs'
import Payment from '../Payment'
import States from 'Components/Elements/Forms/StatesModal/Country/SaudiarabiaStates.json'
import SaudiarabiaAddressData from 'Configs/Address/Saudiarabia/SaudiarabiaAddressData.json'
import { PaymentAPIs } from '../PaymentServices/PaymentAPI'
import ServicePointList from 'Configs/Address/Saudiarabia/ServicePointData.json'
import storeCheckout from '../StoreCheckout'
import { TrackingEvents } from 'Services/Tracker/TrackerConfigs'
import storeCountry from 'GlobalStores/Cores/County/StoreCountry'
import { FormatAPIs } from 'Services/FeelGreat/FormatAPIs'
import trackingEvents from 'Services/Tracker/TrackingEvents'
import storeAuth from 'GlobalStores/User/StoreAuth'
import storeCredit from 'GlobalStores/StoreCredit'
import StoreTranslate from 'GlobalStores/Cores/Translator/StoreTranslate'
import { objectToQueryString } from 'Helpers/GlobalHelpers'
import storeFeelGreat from 'GlobalStores/FeelGreat/StoreFeelGreat'

class SaudiArabia {
    autoAddressDisplayKeys = ['street', 'locality', 'postal_code']
    autoAddressKeyToForm = {
        street: 'address',
        locality: 'city_selection',
        administrative_area: 'district_selection'
    }

    chainAddress = {
        isChainAddress: true,
        groupAddress: ['city_selection', 'district_selection']
    }

    uuid = ''
    selectedShippingPaymentOption = null
    addressListOptions = []
    prefixPhoneNumber = ''
    dialCode = '+966'

    toFormat = {
        enroll: {
            uuid: this.GetUuid(),
            city: '',
            // zip: '',
            email: '',
            phone: '',
            password: '',
            shipment_options: 'delivery'
        },
        enrollWithReferral: {
            uuid: this.GetUuid(),
            city: '',
            // zip: '',
            email: '',
            phone: '',
            password1: '',
            password2: '',
            shipment_options: 'delivery'
        },
        shop: {
            uuid: this.GetUuid(),
            city: '',
            // zip: '',
            email: '',
            shipment_options: 'delivery'
        }
    }

    formShop = {
        fullName: '',
        email: '',
        phone: '',
        street_address: '',
        city: '',
        state: '',
        zip_code: ''
    }

    createAccountWithShippingAddress = {
        type: 'enroll',
        referral_id: '',
        // firstname_en: '',
        // lastname_en: '',
        fullname: '',
        email: '',
        phone: '',
        password: '',
        // city: '',
        // district: '',
        // zip: '',
        period: '',
        shipment_options: 'delivery'
    }

    ExcludedFieldsShippingIfCreateAccount = []

    ExcludedFieldsShipping = []

    mapFormKeyToFormatKey = {
        street_address: 'address',
        city_selection: 'region',
        district_selection: 'city',
        // firstname: 'firstname_en',
        // lastname: 'lastname_en',
        fullName: 'fullname',
        area: 'landmark',
        shipping_method_selection: 'service_point',
        sns_city_code: 'national_address'
    }

    ArrangeCreateCheckoutForm = ['fullName', 'email', 'password', 'phone', 'country', 'sns_city_code', 'city_selection', 'district_selection', 'address', 'area', 'shipping_method_selection']

    PaymentStep = {
        payment: 0,
        createOrder: 0,
        autoship: -2,
        updateLog: 0
    }

    breadcrumbOption = [
        {
            caption: 'customise',
            link: '/products',
            paramsRequire: false
        },
        {
            caption: 'signup_shipping',
            link: '/checkout/create-account',
            paramsRequire: true,
            authCaption: 'shipping',
            authLink: '/checkout/shipping'
        },
        {
            caption: 'purchase',
            link: '/checkout/payment',
            paramsRequire: true
        }
        // {
        //     caption: 'billing',
        //     link: '/checkout/payment',
        //     paramsRequire: true
        // },
        // {
        //     caption: 'purchase',
        //     link: '/checkout/review',
        //     paramsRequire: true
        // }
    ]

    shippingMethods = [
        {
            id: 1,
            api_value: 'delivery',
            title: 'home_delivery',
            dict_key: 'home_delivery',
            for_status: [],
            options: [
                {
                    id: 1,
                    title: 'bank_wire',
                    dict_key: 'bank_transfer',
                    value: 'bankwire',
                    for_status: [],
                    descripion: {
                        title: '',
                        dict_key: ''
                    },
                    icon: ''
                },
                {
                    id: 2,
                    title: 'creditcard',
                    dict_key: 'myfatoorah',
                    value: 'creditcard',
                    for_status: [],
                    descripion: {
                        title: '',
                        dict_key: ''
                    },
                    icon: ''
                }
                // {
                //     id: 3,
                //     title: 'cash_on_delivery',
                //     dict_key: 'cash_on_delivery',
                //     value: 'cashOnDelivery',
                //     for_status: [],
                //     descripion: {
                //         title: '',
                //         dict_key: ''
                //     },
                //     icon: '',
                // }
            ]
        }
        // {
        //     id: 2,
        //     api_value: 'pickuppoint',
        //     title: 'pickup_saudiarabia_office',
        //     dict_key: 'pick_up_service_point',
        //     for_status: [],
        //     options: [
        //         {
        //             id: 1,
        //             title: 'bank_wire',
        //             dict_key: 'bank_transfer',
        //             value: 'bankwire',
        //             for_status: [],
        //             descripion: {
        //                 title: '',
        //                 dict_key: ''
        //             },
        //             icon: '',
        //         },
        //         {
        //             id: 1,
        //             title: 'creditcard',
        //             dict_key: 'myfatoorah',
        //             value: 'creditcard',
        //             for_status: [],
        //             descripion: {
        //                 title: '',
        //                 dict_key: ''
        //             },
        //             icon: '',
        //         },
        //     ]
        // }
        // ------------------------- if get pickup point comeback can remove comment index 2 ------------------------- //
    ]

    // PaymentGateway = 'hydra3ds'
    paymentMethod = 'creditCard'

    orderSummaryConfig = {
        subTotal: {
            display: true,
            dict_key: 'subtotal'
        },
        shipping: {
            display: true,
            dict_key: 'shipping',
            fromOrderCal: true
        },
        productCredit: {
            display: true,
            dict_key: 'product_credit',
            icon: false,
            allowToUse: [],
            allowToEdit: false
        },
        vat: {
            display: false,
            dict_key: 'vat',
            value: 0.2 // 20%
        }
        // shippingWithoutMethod: {
        //     display: true,
        //     displayStep: ['payment'],
        //     dict_key: 'shipping'
        // }
    }

    landingLayouts = [
        {
            nameComponent: 'banner',
            titleContent: 'mainBanner',
            style: {}
        },
        {
            nameComponent: 'ourApproach',
            titleContent: 'ourApproach',
            style: {
                minHeight: '0px'
            }
        },
        {
            nameComponent: 'theProducts',
            titleContent: 'theProducts',
            style: {
                backgroundColor: '#F1F6FB'
            }
        },
        {
            nameComponent: 'thePractice',
            titleContent: 'thePractice',
            style: {}
        },
        {
            nameComponent: 'howItWorks',
            titleContent: 'howItWorks',
            style: {
                backgroundColor: '#FBF7F1'
            }
        },
        {
            nameComponent: 'whatExpertsSay',
            titleContent: 'expertsSay',
            style: {}
        },
        {
            nameComponent: 'realResults',
            titleContent: 'realResults',
            style: {
                backgroundColor: '#F2F9F8'
            }
        }
    ]

    productLayouts = [
        {
            nameComponent: 'productDetailSelection',
            titleContent: 'productDetailSelection',
            style: {}
        },
        {
            nameComponent: 'theProducts',
            titleContent: 'theProducts',
            style: {}
        },
        {
            nameComponent: 'frequentlyAskedQuestions',
            titleContent: 'questions',
            style: {
                backgroundColor: '#F6F9FC'
            }
        }
    ]


    // CustomCreateAccountFormsLoginPage = [
    //     {
    //         "key": "fullName",
    //         "args": null,
    //         "info": "",
    //         "type": "text",
    //         "label": "full_name",
    //         "value": "",
    //         "placeholder": ""
    //     },
    //     {
    //         "key": "email",
    //         "args": null,
    //         "info": "",
    //         "type": "text",
    //         "label": "email_address",
    //         "value": "",
    //         "placeholder": ""
    //     },
    //     {
    //         "key": "password",
    //         "args": {
    //             "onEnroll": true
    //         },
    //         "info": "fg_password_info",
    //         "type": "password",
    //         "label": "password",
    //         "value": "",
    //         "placeholder": ""
    //     },
    //     {
    //         "key": "phone",
    //         "args": {
    //             "regx": "^[0-9]+$"
    //         },
    //         "info": "",
    //         "type": "text",
    //         "label": "Phone Number",
    //         "value": "",
    //         "placeholder": ""
    //     },
    //     {
    //         "key": "country",
    //         "args": {
    //             "disabled": true
    //         },
    //         "info": "",
    //         "type": "CountryBox",
    //         "label": "",
    //         "value": "Saudi Arabia",
    //         "placeholder": ""
    //     }
    // ]

    // CustomCreateAccountForms = [
    //     {
    //         "key": "fullName",
    //         "args": null,
    //         "info": "",
    //         "type": "text",
    //         "label": "full_name",
    //         "value": "",
    //         "placeholder": ""
    //     },
    //     {
    //         "key": "email",
    //         "args": null,
    //         "info": "",
    //         "type": "text",
    //         "label": "email_address",
    //         "value": "",
    //         "placeholder": ""
    //     },
    //     {
    //         "key": "password",
    //         "args": {
    //             "onEnroll": true
    //         },
    //         "info": "fg_password_info",
    //         "type": "password",
    //         "label": "password",
    //         "value": "",
    //         "placeholder": ""
    //     },
    //     {
    //         "key": "phone",
    //         "args": {
    //             "regx": "^[0-9]+$"
    //         },
    //         "info": "",
    //         "type": "text",
    //         "label": "Phone Number",
    //         "value": "",
    //         "placeholder": ""
    //     },
    //     {
    //         "key": "country",
    //         "args": {
    //             "disabled": true
    //         },
    //         "info": "",
    //         "type": "CountryBox",
    //         "label": "",
    //         "value": "Saudi Arabia",
    //         "placeholder": ""
    //     }, {
    //         "key": "city_selection",
    //         "args": null,
    //         "info": "",
    //         "type": "select",
    //         "label": "City selection",
    //         "value": "",
    //         "placeholder": "select_your_city"
    //     },
    //     {
    //         "key": "district_selection",
    //         "args": null,
    //         "info": "",
    //         "type": "select",
    //         "label": "district selection",
    //         "value": "",
    //         "placeholder": "select_your_district"
    //     },
    //     {
    //         "key": "address",
    //         "args": null,
    //         "info": "",
    //         "type": "text",
    //         "label": "address",
    //         "value": "",
    //         "placeholder": ""
    //     },
    //     {
    //         "key": "area",
    //         "args": null,
    //         "info": "",
    //         "type": "text",
    //         "label": "area",
    //         "value": "",
    //         "placeholder": ""
    //     },
    //     {
    //         "key": "shipping_method_selection",
    //         "args": null,
    //         "info": "",
    //         "type": "select",
    //         "label": "Shipping method selection",
    //         "value": "",
    //         "placeholder": "select_your_shipping_method"
    //     }
    // ]

    // CustomShippingForms = [
    //     {
    //         "key": "fullName",
    //         "args": null,
    //         "info": "",
    //         "type": "text",
    //         "label": "full_name",
    //         "value": "",
    //         "placeholder": ""
    //     },
    //     {
    //         "key": "email",
    //         "args": null,
    //         "info": "",
    //         "type": "text",
    //         "label": "email_address",
    //         "value": "",
    //         "placeholder": ""
    //     },
    //     {
    //         "key": "phone",
    //         "args": {
    //             "regx": "^[0-9]+$"
    //         },
    //         "info": "",
    //         "type": "text",
    //         "label": "Mobile Number",
    //         "value": "",
    //         "placeholder": ""
    //     },
    //     {
    //         "key": "country",
    //         "args": {
    //             "disabled": true
    //         },
    //         "info": "",
    //         "type": "CountryBox",
    //         "label": "",
    //         "value": "Saudi Arabia",
    //         "placeholder": ""
    //     },
    //     {
    //         "key": "city_selection",
    //         "args": null,
    //         "info": "",
    //         "type": "select",
    //         "label": "City selection",
    //         "value": "",
    //         "placeholder": "select_your_city"
    //     },
    //     {
    //         "key": "district_selection",
    //         "args": null,
    //         "info": "",
    //         "type": "select",
    //         "label": "district selection",
    //         "value": "",
    //         "placeholder": "select_your_district"
    //     },
    //     {
    //         "key": "address",
    //         "args": null,
    //         "info": "",
    //         "type": "text",
    //         "label": "address",
    //         "value": "",
    //         "placeholder": ""
    //     },
    //     {
    //         "key": "area",
    //         "args": null,
    //         "info": "",
    //         "type": "text",
    //         "label": "area",
    //         "value": "",
    //         "placeholder": ""
    //     },
    //     {
    //         "key": "shipping_method_selection",
    //         "args": null,
    //         "info": "",
    //         "type": "select",
    //         "label": "Shipping method selection",
    //         "value": "",
    //         "placeholder": "select_your_shipping_method"
    //     }
    // ]

    ServicePointList() {
        let items = []
        ServicePointList.map(raw => {
            items.push({
                text: raw.address,
                value: raw.address,
                html: `<span>${raw.address}</span>`
            })
        })
        return items
    }

    StatesList() {
        const StatesList = this.GetAddressListOptions()
        const stationSelected = storeCheckout.GetCheckoutForms().find(item => item.key === 'city_selection')
        const stationSelectedValue = stationSelected.value
        let items = []

        if (stationSelectedValue === '') {
            StatesList.map(raw => {
                items.push({
                    text: raw['City Name'],
                    value: raw['City Name'],
                    html: `<span>${raw['City Name']}</span>`
                })
            })
        }

        const filteredStates = StatesList.filter(raw => raw['Station Name'] === stationSelectedValue)
        filteredStates.map(raw => {
            items.push({
                text: raw['City Name'],
                value: raw['City Name'],
                html: `<span>${raw['City Name']}</span>`
            })
        })
        return items
    }

    AddressOptionList(key = '', fn) {
        // key have city_selection === region, district_selection === city
        const addressData = this.GetAddressListOptions()

        //note: city_selection is region, district_selection is city
        let items = { region: [], city: [] }

        const uniqueRegion = [...new Set(addressData.map(item => item.region_name_native))].sort()
        const region = uniqueRegion.map(item => {
            return {
                region_name: item
            }
        })

        region.map(raw => {
            items = {
                ...items,
                region: [
                    ...items.region,
                    {
                        text: raw.region_name,
                        value: raw.region_name,
                        html: `<span>${raw.region_name}</span>`
                    }
                ]
            }
        })

        const regionValue = get(
            (fn.GetCheckoutForms() || []).find(item => item.key === 'city_selection'),
            'value'
        )

        if (regionValue) {
            const filteredCityByRegion = addressData.filter(raw => raw[StoreTranslate.IsEnglish() ? 'region_name_english' : 'region_name_native'] === regionValue)

            const sortedCities = filteredCityByRegion.map(raw => raw[StoreTranslate.IsEnglish() ? 'city_name_english' : 'city_name_native']).sort()

            sortedCities.forEach(city => {
                items = {
                    ...items,
                    city: [
                        ...items.city,
                        {
                            text: city,
                            value: city,
                            html: `<span>${city}</span>`
                        }
                    ]
                }
            })
        } else {
            items = {
                ...items,
                city: []
            }
        }

        return key === 'city_selection' ? items.region : items.city
    }

    MapAutoAddressToForm(form, autoAddressData) {
        const data = autoAddressData?.data || {}

        // Normalize for transliteration variance: lower-case, strip non-letters,
        // drop the "al"/"el" article prefix, drop trailing aspirate "h"
        // ("Bahah" ⇄ "Baha", "Mekhwah" ⇄ "Mekhwa").
        const normalize = value =>
            String(value || '')
                .toLowerCase()
                .replace(/[^a-z0-9؀-ۿ]/gi, '')
                .replace(/^(al|el)/, '')
                .replace(/h$/, '')

        // Levenshtein distance — tolerant of single vowel/consonant swaps so
        // "Mekhwa" matches "Mikhwa".
        const levenshtein = (a, b) => {
            if (a === b) return 0
            if (!a) return b.length
            if (!b) return a.length
            const dp = Array.from({ length: a.length + 1 }, (_, i) => [i])
            for (let j = 1; j <= b.length; j++) dp[0][j] = j
            for (let i = 1; i <= a.length; i++) {
                for (let j = 1; j <= b.length; j++) {
                    dp[i][j] = Math.min(
                        dp[i - 1][j] + 1,
                        dp[i][j - 1] + 1,
                        dp[i - 1][j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1)
                    )
                }
            }
            return dp[a.length][b.length]
        }

        const bestFuzzyMatch = (target, pool, getter) => {
            if (!target) return null
            // Tier 1: exact normalized match
            const exact = pool.find(row => normalize(getter(row)) === target)
            if (exact) return exact
            // Tier 2: bidirectional prefix match
            const prefix = pool.find(row => {
                const n = normalize(getter(row))
                return n && (n.startsWith(target) || target.startsWith(n))
            })
            if (prefix) return prefix
            // Tier 3: best Levenshtein within a similarity threshold (≥70%)
            let best = null
            let bestScore = 0
            pool.forEach(row => {
                const n = normalize(getter(row))
                if (!n) return
                const distance = levenshtein(target, n)
                const score = 1 - distance / Math.max(target.length, n.length)
                if (score > bestScore && score >= 0.7) {
                    best = row
                    bestScore = score
                }
            })
            return best
        }

        // The address list's `region_name_english` is the Unicity shipping zone
        // (e.g. "Hofuf", "Jeddah"), NOT Saudi's administrative region. Smarty's
        // `administrative_area` (e.g. "Eastern Province") rarely matches a zone,
        // so we resolve by city instead and read the zone off the matched row.
        const findCityRow = (locality, fallbackAdminArea) => {
            const cityTarget = normalize(locality)
            if (cityTarget) {
                const cityMatch = bestFuzzyMatch(cityTarget, this.addressListOptions, row => row.city_name_english)
                if (cityMatch) return cityMatch
            }
            // Fallback: try matching locality against zone names (some Smarty
            // responses put the city in `administrative_area` instead).
            const adminTarget = normalize(fallbackAdminArea)
            if (adminTarget) {
                const seen = new Set()
                const zones = this.addressListOptions.filter(row => {
                    if (!row.region_name_english || seen.has(row.region_name_english)) return false
                    seen.add(row.region_name_english)
                    return true
                })
                const zoneMatch = bestFuzzyMatch(adminTarget, zones, row => row.region_name_english)
                if (zoneMatch) return zoneMatch
            }
            return null
        }

        // Smarty's leaf for SAU carries the 8-char Saudi National Address (SNS) short
        // code — 4 letters + 4 digits, e.g. "BAAA2761". When the user searches BY that
        // code it sits at the front of `street` ("BAAA2761 2761 King Fahd Road"), but
        // when the user searches by street name the resolved leaf can carry the code
        // elsewhere — or only inside `address_text` — not anchored to the front of
        // `street`. So scan the whole candidate (street first, then address_text, then a
        // deep fallback) rather than only the front of `street`. This is what lets the
        // National Address field auto-fill no matter which field the search started in.
        const SNS_CODE_REGEX = /\b[A-Z]{4}\d{4}\b/
        const findSnsCode = source => {
            if (typeof source === 'string') {
                const match = source.match(SNS_CODE_REGEX)
                return match ? match[0] : ''
            }
            if (source && typeof source === 'object') {
                for (const value of Object.values(source)) {
                    const found = findSnsCode(value)
                    if (found) return found
                }
            }
            return ''
        }
        const snsCode = findSnsCode(data.street) || findSnsCode(data.address_text) || findSnsCode(data)
        const streetWithoutSns =
            typeof data.street === 'string'
                ? data.street
                      .replace(SNS_CODE_REGEX, '')
                      .replace(/\s{2,}/g, ' ')
                      .replace(/^[\s,]+/, '')
                      .trim() || data.street
                : data.street

        const cityRow = findCityRow(data.locality, data.administrative_area)
        const resolvedZone = cityRow ? cityRow.region_name_english : ''
        const resolvedCity = cityRow ? cityRow.city_name_english : ''

        // Route writes through SetCheckoutFormValue so they go through runInAction
        // and update both `forms` and `shippingForms` consistently. The shipping
        // form renames `sns_city_code` → `national_address` in-place during render,
        // so write both keys to cover either state.
        runInAction(() => {
            if (streetWithoutSns) {
                storeCheckout.SetCheckoutFormValue('address', streetWithoutSns)
            }
            if (snsCode) {
                storeCheckout.SetCheckoutFormValue('sns_city_code', snsCode)
                storeCheckout.SetCheckoutFormValue('national_address', snsCode)
            }
            if (resolvedZone) {
                storeCheckout.SetCheckoutFormValue('city_selection', resolvedZone)
            }
        })

        // district_selection is set on a deferred tick. SaudiarabiaSelect has a
        // mobx reaction on `city_selection` that clears district_selection
        // whenever the parent changes — writing district synchronously here
        // would be wiped by that reaction. Wait a tick so the clear lands first,
        // then set the resolved city.
        if (resolvedCity) {
            setTimeout(() => {
                storeCheckout.SetCheckoutFormValue('district_selection', resolvedCity)
            }, 100)
        }

        return form
    }

    FormToFormat(type, form) {
        form.map(item => {
            if (this.mapFormKeyToFormatKey[item.key]) {
                if (this.toFormat[type]) {
                    runInAction(() => {
                        this.toFormat[type][this.mapFormKeyToFormatKey[item.key]] = item.value
                    })
                }
            } else {
                if (this.toFormat[type]) {
                    runInAction(() => {
                        this.toFormat[type][item.key] = item.value
                    })
                }
            }

            return item
        })
    }

    GetDialCode() {
        return this.dialCode
    }

    SetDialCode(value) {
        this.dialCode = value
    }

    SetUuid(value) {
        this.uuid = value
    }

    GetUuid() {
        return this.uuid
    }

    GetFormat(type) {
        return this.toFormat[type]
    }

    GetPaymentStep() {
        return this.PaymentStep
    }

    GetBreadcrumbOption() {
        return this.breadcrumbOption
    }

    GetShippingMethod() {
        return this.shippingMethods
    }

    pageConfig = {
        signUp: {
            disable: true
        }
    }

    GetPageConfig() {
        return this.pageConfig
    }

    SetPaymentStep(key, value) {
        this.PaymentStep[key] = value
    }

    GetOrderSummaryConfig() {
        return this.orderSummaryConfig
    }

    SetSelectedShippingPaymentOption(value) {
        this.selectedShippingPaymentOption = value
    }

    GetSelectedShippingPaymentOption() {
        return this.selectedShippingPaymentOption
    }

    GetLandingLayout() {
        return this.landingLayouts
    }

    GetProductLayout() {
        return this.productLayouts
    }

    GetPaymentMethod() {
        return this.paymentMethod
    }

    SetPaymentMethod(value) {
        runInAction(() => {
            this.paymentMethod = value
        })
    }

    SetAddressListOptions(value) {
        runInAction(() => {
            this.addressListOptions = value
        })
    }

    GetAddressListOptions() {
        return this.addressListOptions
    }

    /**
     *
     * @param {*} uuid
     * @param {object} detailPage { products, detailPage, isSubscribe, isEnroll, type}
     * @param {*} CreditCardEncrypted
     * @param {*} billingAddressForm
     * @param {*} products
     * @param {*} options
     * @param {*} type
     * @param {*} CreditCardAlias
     */

    async SubmitPayment(uuid, detailPage, CreditCardEncrypted, billingAddressForm, products, options, type, CreditCardAlias) {
        const Pay = new Payment(uuid, detailPage)
        try {
            const responsePreparePayment = await Pay.PreparePaymentData()
            // USHOP-2686: the SAU toggle uses syncCreditUsed={false}, so storeCredit.creditUsed is
            // NOT cleared when the user turns product credit off. The MyFatoorah path reads the BE
            // split (formatTotal), but the Hydra paths (subscription / saved-card / COD) must gate on
            // the toggle itself, otherwise credit is applied even when the toggle is off.
            const allowCreditEnable = storeAuth.IsAllowCredit() && storeCheckout.getIsApplyProductCredit()

            if (!Pay.hydra.transactions) {
                Pay.hydra.transactions = {}
            }

            if (CreditCardAlias && CreditCardAlias.length > 0) {
                const creditCardAliasData = {
                    type: 'AuthorizeAndCapture',
                    method: 'CreditCardAlias',
                    methodDetails: {
                        alias: CreditCardAlias
                    },
                    amount: 'this.terms.total'
                }

                if (allowCreditEnable && storeCredit.GetCreditData()?.creditUsed > 0) {
                    let amount = Number(Pay.ushop.total_price) - Number(storeCredit.ProductCreditUsed().amount)
                    if (amount > 0) {
                        creditCardAliasData.amount = Number(amount)
                        Pay.hydra.transactions = {
                            items: [creditCardAliasData, storeCredit.ProductCreditUsed()]
                        }
                    } else {
                        Pay.hydra.transactions = {
                            items: [storeCredit.ProductCreditUsed()]
                        }
                    }
                } else {
                    Pay.hydra.transactions = {
                        items: [creditCardAliasData]
                    }
                }
            } else {
                if (allowCreditEnable && storeCredit.GetCreditData()?.creditUsed > 0) {
                    Pay.hydra.transactions = {
                        items: [CreditCardEncrypted, storeCredit.ProductCreditUsed()]
                    }
                } else {
                    Pay.hydra.transactions = {
                        items: [CreditCardEncrypted]
                    }
                }
            }

            const hasSubscribe = /subscribe/i.test(detailPage.shipment_packs)

            if (hasSubscribe) {
                await Pay.PostToHydraWithCreateAutoShip()
            } else {
                await Pay.PostToHydra()
            }

            Pay.SendEmailV4()

            if (hasSubscribe) {
                await Pay.UpdateToLog(Pay.hydra.transactions, 1, false, 'success')
            } else {
                await Pay.UpdateToLog(Pay.hydra.transactions, 0, false, 'success')
            }

            const responsePaymentDetail = await PaymentAPIs.GetPaymentDetail(responsePreparePayment.data.data.payment_id)
            runInAction(() => {
                StorePaymentStep.PaymentDone = true
            })

            try {
                trackingEvents.PurchaseEvent({
                    transaction_id: responsePreparePayment.data.data.payment_id,
                    value: Pay.ushop.total_price,
                    currency: 'SAR',
                    category: Pay.ushop.shipment_purchas_option,
                    items: products
                })
            } catch (e) {
                console.error('TrackingEvents.PurchaseEvent', e)
            }

            return {
                success: true,
                payment_id: responsePreparePayment.data.data.payment_id,
                order_number: responsePaymentDetail.data.order_number
            }
        } catch (error) {
            console.error(error)
            const hasSubscribe = /subscribe/i.test(detailPage.shipment_packs)
            Pay.UpdateToLog(Pay.hydra.transactions, hasSubscribe ? 1 : 0, true, 'error')
            runInAction(() => {
                StorePaymentStep.PaymentDone = true
            })
            return { success: false }
        }
    }

    async SubmitCashOnDeliveryPayment(uuid, detailPage, products) {
        const Pay = new Payment(uuid, detailPage)

        try {
            // USHOP-2686: the SAU toggle uses syncCreditUsed={false}, so storeCredit.creditUsed is
            // NOT cleared when the user turns product credit off. The MyFatoorah path reads the BE
            // split (formatTotal), but the Hydra paths (subscription / saved-card / COD) must gate on
            // the toggle itself, otherwise credit is applied even when the toggle is off.
            const allowCreditEnable = storeAuth.IsAllowCredit() && storeCheckout.getIsApplyProductCredit()
            const data = {
                uuid: uuid,
                payment_options: 'cashondelivery',
                shipment_packs: JSON.stringify(storeCheckout.GetCart())
            }

            const responseFormat = await FormatAPIs.putHotFormatV2(data, storeCountry.Country3())
            if (responseFormat) {
                const Pay = new Payment(uuid, detailPage)
                const responsePreparePayment = await Pay.PreparePaymentData() // member-calls2/hydra-value

                if (!Pay.hydra.transactions) {
                    Pay.hydra.transactions = {}
                }

                const transaction = { ...responsePreparePayment.data?.data?.hydra?.transactions }

                Pay.hydra.transactions = transaction

                // ------------------------------------------------------------

                if (allowCreditEnable && storeCredit.GetCreditData()?.creditUsed > 0) {
                    const productCredit = storeCredit.GetCreditData()

                    if (productCredit.creditType === 'cashCoupon') {
                        Pay.hydra.transactions.items.push({ ...storeCredit.cashCouponForm, amount: productCredit.creditUsed })
                    }
                    if (productCredit.creditType === 'arBalance') {
                        Pay.hydra.transactions.items.push({ ...storeCredit.arBalanceForm, amount: storeCheckout.GetFinalARBalance() })
                    }
                }

                // ------------------------------------------------------------
                await Pay.PostToHydra() //hydra create order
                
                Pay.SendEmailV4()
                
                const hasSubscribe = /subscribe/i.test(detailPage.shipment_packs)
                await Pay.UpdateToLog(Pay.hydra.transactions, hasSubscribe ? 1 : 0, false, 'success')

                let baId = storeAuth.GetId() || undefined
                const responsePaymentDetail = await FeelGreatAPI.GetPaymentDetail(responsePreparePayment.data.data.payment_id, baId)
                runInAction(() => {
                    StorePaymentStep.PaymentDone = true
                })

                try {
                    trackingEvents.PurchaseEvent({
                        transaction_id: responsePreparePayment.data.data.payment_id,
                        value: Pay.ushop.total_price,
                        currency: 'SAR',
                        category: Pay.ushop.shipment_purchas_option,
                        items: products
                    })
                } catch (e) {
                    console.error('TrackingEvents.PurchaseEvent', e)
                }

                return {
                    success: true,
                    payment_id: responsePreparePayment.data.data.payment_id,
                    order_number: responsePaymentDetail.data.order_number
                }
            }
        } catch (error) {
            console.error(error)
            const hasSubscribe = /subscribe/i.test(detailPage.shipment_packs)
            Pay.UpdateToLog(Pay.hydra.transactions, hasSubscribe ? 1 : 0, true, 'error')
            runInAction(() => {
                StorePaymentStep.PaymentDone = true
            })

            return { success: false }
        }
    }

    async SubmitBankwirePayment(uuid, detailPage, products) {
        const Pay = new Payment(uuid, detailPage)
        
        try {
            const responsePreparePayment = await Pay.PreparePaymentData()

            if (!Pay.hydra.transactions) {
                Pay.hydra.transactions = {}
            }

            // USHOP-2686: the SAU toggle uses syncCreditUsed={false}, so storeCredit.creditUsed is
            // NOT cleared when the user turns product credit off. The MyFatoorah path reads the BE
            // split (formatTotal), but the Hydra paths (subscription / saved-card / COD) must gate on
            // the toggle itself, otherwise credit is applied even when the toggle is off.
            const allowCreditEnable = storeAuth.IsAllowCredit() && storeCheckout.getIsApplyProductCredit()

            Pay.hydra.transactions = {
                items: [
                    {
                        amount: 'this.terms.total',
                        type: 'IOU',
                        method: 'BankWire',
                        billToEmail: responsePreparePayment.data.data.hydra.shipToEmail,
                        billToPhone: responsePreparePayment.data.data.hydra.shipToPhone,
                        billToAddress: {
                            country: storeCountry.Country2()
                        }
                    }
                ]
            }

            // ------------------------------------------------------------

            if (allowCreditEnable && storeCredit.GetCreditData()?.creditUsed > 0) {
                const productCredit = storeCredit.GetCreditData()

                if (productCredit.creditType === 'cashCoupon') {
                    Pay.hydra.transactions.items.push({ ...storeCredit.cashCouponForm, amount: productCredit.creditUsed })
                }
                if (productCredit.creditType === 'arBalance') {
                    Pay.hydra.transactions.items.push({ ...storeCredit.arBalanceForm, amount: storeCheckout.GetFinalARBalance() })
                }
            }
            // ------------------------------------------------------------

            await Pay.PostToHydra()

            Pay.SendEmailV4()

            const hasSubscribe = /subscribe/i.test(detailPage.shipment_packs)
            await Pay.UpdateToLog(Pay.hydra.transactions, hasSubscribe ? 1 : 0, false, 'success')

            const responsePaymentDetail = await PaymentAPIs.GetPaymentDetail(responsePreparePayment.data.data.payment_id)
            runInAction(() => {
                StorePaymentStep.PaymentDone = true
            })
            try {
                trackingEvents.PurchaseEvent({
                    transaction_id: responsePreparePayment.data.data.payment_id,
                    value: Pay.ushop.total_price,
                    currency: 'SAR',
                    category: Pay.ushop.shipment_purchas_option,
                    items: products
                })
            } catch (e) {
                console.error('TrackingEvents.PurchaseEvent', e)
            }
            return {
                success: true,
                payment_id: responsePreparePayment.data.data.payment_id,
                order_number: responsePaymentDetail.data.order_number
            }
        } catch (error) {
            console.error(error)
            const hasSubscribe = /subscribe/i.test(detailPage.shipment_packs)
            Pay.UpdateToLog(Pay.hydra.transactions, hasSubscribe ? 1 : 0, true, 'error')
            runInAction(() => {
                StorePaymentStep.PaymentDone = true
            })

            return { success: false, error: error }
        }
    }

    async CreateAccount(uuid, accForm, shippingForm, referral, cartItems, shippingMethod) {
        try {
            const forms = Object.assign(this.createAccountWithShippingAddress, accForm)
            const returnShippingAddress = {}
            shippingForm.map(item => {
                if (this.ExcludedFieldsShippingIfCreateAccount.includes(item.key)) {
                    return false
                }

                if (this.mapFormKeyToFormatKey[item.key]) {
                    forms[this.mapFormKeyToFormatKey[item.key]] = item.value
                    returnShippingAddress[this.mapFormKeyToFormatKey[item.key]] = item.value
                } else {
                    forms[item.key] = item.value
                    returnShippingAddress[item.key] = item.value
                }
            })

            if (referral) {
                forms.referral_id = referral
            } else {
                delete forms.referral_id
            }

            if (!shippingMethod) {
                return {
                    success: false,
                    shippingMethodIsRequired: true
                }
            }

            delete forms.country

            const periodResponse = await FeelGreatAPI.GetPeriod('SA')
            forms.period = periodResponse.data.entryPeriod
            forms.uuid = uuid
            forms.shipment_packs = JSON.stringify(cartItems)
            forms.shipment_options = shippingMethod
            forms.country_calling_code = this.GetDialCode().replace('+', '')

            if (shippingMethod === 'pickuppoint') {
                delete forms['address']
                delete forms['landmark']
            }

            const queryStrings = objectToQueryString({
                dev: ServerEnv.ENV === 'DEV' ? '1' : undefined,
                emailDelay: ServerEnv.ENV === 'DEV' ? undefined : '1h',
                isSkipCheckPassword: storeFeelGreat.passwordSettings.isUseComplexPassword ? '1' : undefined
            })

            const url = `https://${ServerEnv.MemberCalls2()}.unicity.com/hot/formatV2/SAU/feelGreat/createAccount${queryStrings}`
            const response = await axios.post(url, forms)

            return {
                ...response.data,
                form: forms
            }
        } catch (e) {
            console.error(e)

            return {
                success: false
            }
        }
    }

    SpecialAreasDeliveryFeeCondition(step) {
        let totalPrice = 0

        // const shippingMethod = storeCheckout.GetShippingMethod()
        // const city = storeCheckout.GetShippingForm().find(item => item.key === 'city_selection' && item.value)

        // // has shipfee for delivery
        // if (get(shippingMethod, 'api_value') === 'pickup' || !this.orderSummaryConfig.shippingWithoutMethod.displayStep.includes(step)) return totalPrice

        // const products = toJS(StoreProducts.GetProducts())
        // const onetimeItems = get(storeCheckout.GetCart(), 'onetime')
        // let totalOnetimePV = 0

        // if (!isEmpty(onetimeItems)) {
        //     const onetimeProducts = Object.keys(onetimeItems)
        //     onetimeProducts.forEach(item => {
        //         const productPV = get(products, [item, 'onetime', 'pv'], 0)
        //         const productQty = get(onetimeItems, item, 0)
        //         totalOnetimePV = totalOnetimePV + productPV * productQty
        //     })
        // }

        // console.log('city', city)

        // if (['amman'].includes(get(city, 'value', '').toLowerCase())) {
        //     totalPrice = 2.5
        // } else if (['zarqa'].includes(get(city, 'value', '').toLowerCase())) {
        //     totalPrice = 3
        // } else {
        //     totalPrice = 4
        // }

        // if (totalOnetimePV > 50) {
        //     totalPrice = 0
        // }

        return totalPrice
    }
    constructor() {
        StorePaymentStep.SetPaymentSteps(this.PaymentStep)
        makeAutoObservable(this)
    }
}

export default SaudiArabia
